{ "compressionlevel":-1,
 "height":14,
 "infinite":false,
 "layers":[
        {
         "draworder":"topdown",
         "id":2,
         "name":"Objects",
         "objects":[
                {
                 "height":0,
                 "id":3,
                 "name":"player",
                 "point":true,
                 "rotation":0,
                 "type":"player",
                 "visible":true,
                 "width":0,
                 "x":64,
                 "y":128
                }, 
                {
                 "ellipse":true,
                 "height":96,
                 "id":6,
                 "name":"target",
                 "rotation":0,
                 "type":"target",
                 "visible":true,
                 "width":96,
                 "x":224,
                 "y":32
                }, 
                {
                 "height":192,
                 "id":9,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":32,
                 "x":160,
                 "y":0
                }, 
                {
                 "height":32,
                 "id":10,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":224,
                 "x":160,
                 "y":192
                }, 
                {
                 "height":192,
                 "id":11,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":64,
                 "x":512,
                 "y":64
                }, 
                {
                 "height":96,
                 "id":12,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":64,
                 "x":320,
                 "y":224
                }, 
                {
                 "height":96,
                 "id":13,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":64,
                 "x":480,
                 "y":352
                }, 
                {
                 "height":96,
                 "id":14,
                 "name":"",
                 "rotation":0,
                 "type":"collider",
                 "visible":true,
                 "width":192,
                 "x":0,
                 "y":352
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        }],
 "nextlayerid":3,
 "nextobjectid":15,
 "orientation":"orthogonal",
 "properties":[
        {
         "name":"levelName",
         "type":"string",
         "value":"Level 5"
        }, 
        {
         "name":"order",
         "type":"int",
         "value":4
        }],
 "renderorder":"right-down",
 "tiledversion":"1.6.0",
 "tileheight":32,
 "tilesets":[],
 "tilewidth":32,
 "type":"map",
 "version":"1.6",
 "width":20
}